export default "__VITE_ASSET__NS_r0XbO__"